import React, { useState } from 'react';
import { Tabs } from 'components';

import { TabsContainer, ContentContainer } from './TableTabbedStyles';
import { CalculationTrace } from 'components/CalculationTrace/CalculationTrace';
import { TimeWindowsTable } from './Content/TimeWindowsTable';
import { TabOptions, useTabsContent } from './hooks/useTabsContent';
import { Column } from 'types/Table';

type Props = {
  data: Array<any>;
  columns: Array<Column>;
  benchmarkName: string | undefined;
  benchmarkId: string | undefined;
  isLoading?: boolean;
};

export const TableTabbed: React.FC<Props> = ({
  data,
  columns,
  isLoading = false,
  benchmarkName,
  benchmarkId,
}) => {
  const contentTabList = useTabsContent();
  const [activeTab, setActiveTab] = useState<string>(TabOptions.TimeWindows);
  const handleSelectTab = (tab: any) => {
    setActiveTab(tab);
  };

  const renderTabsContent = () => {
    switch (activeTab) {
      case TabOptions.CalculationTrace:
        return <CalculationTrace benchmarkId={benchmarkId} />;
      case TabOptions.TimeWindows:
        return (
          <TimeWindowsTable
            columns={columns}
            data={data}
            benchmarkName={benchmarkName}
            isLoading={isLoading}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <TabsContainer>
        <Tabs
          list={contentTabList}
          onChange={handleSelectTab}
          active={activeTab}
        />
        <ContentContainer>{renderTabsContent()}</ContentContainer>
      </TabsContainer>
    </>
  );
};
